import type { MeasureUnitTable } from "../../../../../api/types/svTypes.ts";

export function checkUnitTable(table: MeasureUnitTable | undefined, check: MeasureUnitTable): boolean {
  if (table === undefined) return false;
  return ((table & check) as MeasureUnitTable) === check;
}
